
import React, { useState } from "react";
import { Alert, Col, Row } from "reactstrap";
import HeaderTitle from "../../../../../common/HeaderTitle";
import PopupMsgWrapper from "../../../../../common/PopupMsgWrapper";
import { useDispatch } from "react-redux";
import { responseApproverService } from "../../../../AssesmentForm/TabsComponents/Action";
import { userDetails } from "../../../../../../helper";
import Toaster from "../../../../../common/Toaster";
import { useHistory } from "react-router-dom";
import LoaderCustom from "../../../../../common/LoaderCustom";

const NeedFormReviewRequest = ({ reviewRequestResponseData, viewDataFromSupplier }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  let empId = userDetails();
  const submitResponseButtonFlag = (parseInt(viewDataFromSupplier?.VNFRequester) === parseInt(empId?.EmployeeId));
  const [showPopupForRequestReview, setShowPopupForRequestReview] = useState(false);
  const [showRemarkPopup, setShowRemarkPopup] = useState(false); // New state to control remark input popup
  const [remarkError, setRemarkError] = useState(""); // State to manage remark validation error
  const urlParams = new URLSearchParams(window.location.search);
  const selfAssesmentId = urlParams.get("VendorRequirementRegistrationId");
  const [submitLoading, setSubmitLoading] = useState(false); // State to manage loading status
  const [remarkAccept, setRemarkAccept] = useState("");


  const closePopUpForRequestReview = () => {
    setShowPopupForRequestReview(false);
    setRemarkAccept("")
  };

  const closePopUpForRemark = () => {
    setShowRemarkPopup(false);
    setRemarkAccept("")
  };

  const onPopupConfirmForRequestReview = () => {
    setShowPopupForRequestReview(true);
  };

  const popupInputData = (data) => {
    setRemarkAccept(data);
  };

  const convertISOToUtcDate1 = (isoDate) => {
    const date = new Date(isoDate);
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure month is two digits
    const day = String(date.getDate()).padStart(2, "0"); // Ensure day is two digits
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handleRemarkPopupConfirm = () => {
    if (!remarkAccept) {
      setRemarkError("Please enter a remark");
      setShowRemarkPopup(true);
      return;
    }
    setShowRemarkPopup(false);
    onPopupConfirmForRequestReview();
  };

  const handleSubmitReponse = async (data, workFlowLevel) => {
    if (!remarkAccept) {
      Toaster.error("Please enter a remark");
      return;
    }

    const userDetail = userDetails();
    const reviewRequesterData = {
      Action: data,
      remark: remarkAccept,
      WorkflowLevel: workFlowLevel,
      EmployeeId: parseInt(userDetail?.EmployeeId),
      vendorRequirementRegistrationId: selfAssesmentId,
    };

    try {
      setSubmitLoading(true);
      const res = await new Promise((resolve) => {
        dispatch(responseApproverService(reviewRequesterData, resolve));
      });
      if (res && res?.IsSuccessful) {

        Toaster.success(res?.Data?.Message);
        if (viewDataFromSupplier?.IsBlockedVendor) {
          history.push("/supplier-unblocking-request");
        } else {
          history.push("/vendor-need-list");
        }
      }
    } catch (error) {

    } finally {
      setSubmitLoading(false);
    }
  };

  if (submitLoading) {
    return (
      <div>
        <LoaderCustom customClass="simulation-Loader" />
      </div>
    ); // Render loading indicator if loading is true
  }

  return (
    <>
      {reviewRequestResponseData &&
        reviewRequestResponseData?.Data?.RequestReviews?.length > 0 ? (
        <div className="hl-vendor-approval mt-4">
          {reviewRequestResponseData &&
            reviewRequestResponseData?.Data?.RequestReviews?.map((data) => (
              <Row
                key={data.ReviewRequestId}
                className="hl-need-form mt-3 align-items-center"
              >
                {data.Status === 1 ? (
                  <>
                    <Col lg="3">
                      <div className="d-flex align-items-baseline pt-2">
                        <h3 className="">Requested By:</h3>
                        <p className="ms-3">{data.Name}</p>
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="d-flex align-items-baseline pt-2">
                        <h3 className="">Approver:</h3>
                        <p className="ms-3">{`Level ${data.WorkFlowLevel}`}</p>
                      </div>
                    </Col>
                    <Col md="12"><hr className="hr-seprator mb-2" /></Col>
                    {showPopupForRequestReview && (
                      <PopupMsgWrapper
                        isOpen={showPopupForRequestReview}
                        closePopUp={closePopUpForRequestReview}
                        confirmPopup={() => handleSubmitReponse("Response", data?.WorkFlowLevel)}
                        message={`Are you sure you want to submit the response?`}
                      />
                    )}
                    {showRemarkPopup && (
                      <PopupMsgWrapper
                        setInputData={popupInputData}
                        isOpen={showRemarkPopup}
                        header={"Submit Response"}
                        closePopUp={closePopUpForRemark}
                        confirmPopup={handleRemarkPopupConfirm}
                        isInputFieldResponse={true}
                      />
                    )}
                    <div className="review-request mt-3">
                      <div className="remarks-wrap">
                        <HeaderTitle title={"Remarks:"} customClass="" />
                        <p className="para-color">{data.RequestRemark}
                          <strong className="d-block hl-date-remark">
                            {convertISOToUtcDate1(data.RequestDate)}
                          </strong>
                        </p>
                      </div>
                    </div>
                    {submitResponseButtonFlag &&
                      <Col md="12"><hr className="hr-seprator" /></Col>
                    }
                    <Col lg="12" className="mb-2">
                      {submitResponseButtonFlag &&
                        <button
                          type="submit"
                          className="submit-button save-btn mr-2 mb-0"
                          onClick={() => {
                            setRemarkError(""); // Reset validation error
                            setShowRemarkPopup(true);
                          }}
                        >
                          {"Submit Response"}
                        </button>}
                    </Col>
                  </>
                ) : (
                  <>
                    <Col lg="3">
                      <div className="d-flex align-items-baseline pt-2">
                        <h3 className="fs-6">Requested By: <span className="ps-2 fw-normal">{data?.Name}</span></h3>
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="d-flex align-items-baseline pt-2">
                        <h3 className="fs-6">Approver: <span className="ps-2 fw-normal">{"Level " + data?.WorkFlowLevel}</span></h3>
                      </div>
                    </Col>
                    <Col md="12"><hr className="hr-seprator mb-4" /></Col>
                    <div className="review-request">
                      <div className="remarks-wrap">
                        <HeaderTitle title={"Remarks:"} customHeaderClass="fs-6" />
                        <p className="para-color">{data?.RequestRemark}
                          <strong className="d-block hl-date-remark">
                            {convertISOToUtcDate1(data?.RequestDate)}
                          </strong>
                        </p>
                        <hr className="hr-seprator" />
                      </div>
                      <div className="remarks-wrap ml-4 mt-2">
                        <HeaderTitle title={"Response By : " + data?.ResponseGivenByName} customHeaderClass="fs-6" />
                        <p className="para-color">{data?.ResponseRemark}
                          <strong className="d-block hl-date-remark">
                            {convertISOToUtcDate1(data?.ResponseDate)}
                          </strong>
                        </p>
                      </div>
                    </div>
                  </>
                )}
              </Row>
            ))}
        </div>
      ) : (
        <div className="hl-pending-text">
          <Alert color="warning">
            <h2>
              <span className="font-16 d-flex">
                <i className="fa fa-info-circle mr-2" aria-hidden="true" ></i>
                <span>No review responses available for the approver.</span>
              </span>
            </h2>
          </Alert>
        </div>
      )}
    </>
  );
};

export default NeedFormReviewRequest;

